<template>
  <v-dialog v-model="active" width="400">
    <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData"></slot>
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName"></slot>
    </template>
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-autocomplete v-model="majorToAdd" :items="majorItems" :label="action === 'add' ? 'Major to Add' : (action === 'declare' ? 'Major to Declare' : 'Change Major to')" outlined />
        <v-select v-model="advisor" :items="advisorOptions" label="Requested Advisor" outlined />
        <v-autocomplete v-if="majorToAdd === 'IDS'" v-model="primaryConcentration" :items="primaryConcentrationOptions" label="Primary Concentration" outlined />
        <v-autocomplete v-model="concentrations" :disabled="concentrationOptions.length === 0" :items="concentrationOptions" :label="majorToAdd === 'IDS' ? 'Additional Concentrations (choose 2)' : 'Concentration(s)'" outlined multiple chips small-chips deletable-chips />
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="majorToAdd === '' || advisor === '' || (majorToAdd === 'IDS' && (primaryConcentration === '' || concentrations.length !== 2))" @click="save()" text>{{ title }}</v-btn>
        <v-spacer />
        <v-btn text @click="active = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { computed, ref, watch } from '@vue/composition-api'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      required: true
    },
    majorItems: {
      type: Array,
      required: true
    }
  },
  setup (props, { root, emit }) {
    const active = ref(false)
    const settingServ = root.$feathers.service('student/reg-setting')

    const title = computed(() => {
      if (props.action === 'add') return 'Add Major'
      else if (props.action === 'drop') return 'Drop Major'
      else return 'Change Major'
    })

    const majorToAdd = ref('')

    const advisor = ref('')
    const advisorOptions = ref([])
    watch(majorToAdd, async () => {
      if (majorToAdd.value !== '') {
        advisor.value = ''
        primaryConcentration.value = ''
        concentrations.value = []
        const { data } = await settingServ.find({ query: { form: 'program', major: majorToAdd.value } })
        for (const { category, options } of data) {
          if (category === 'advisor') advisorOptions.value = options
          else if (category === 'concentration') concentrationOptions.value = options
          else if (category === 'primary-concentration') primaryConcentrationOptions.value = options
        }
      }
    })

    const primaryConcentration = ref('')
    const primaryConcentrationOptions = ref([])

    const concentrations = ref([])
    const concentrationOptions = ref([])

    watch(() => props.value, () => {
      if (props.value && !active.value) {
        majorToAdd.value = ''
        advisor.value = ''
        primaryConcentration.value = ''
        concentrations.value = []
        active.value = true
      }
    })
    watch(active, () => {
      if (!active.value) emit('input', false)
    })
    watch(concentrations, () => {
      if (majorToAdd.value === 'IDS' && concentrations.value.length > 2) {
        concentrations.value.splice(2, 1)
      }
    })

    async function save () {
      const obj = { value: majorToAdd.value, advisor: advisor.value, concentrations: concentrations.value }
      if (majorToAdd.value === 'IDS') {
        obj.concentrations.splice(0, 0, primaryConcentration.value)
      }
      emit('save', obj)
      active.value = false
    }

    return {
      active,
      title,
      majorToAdd,
      advisor,
      advisorOptions,
      primaryConcentration,
      primaryConcentrationOptions,
      concentrations,
      concentrationOptions,
      save
    }
  }
}
</script>
